import { render } from "./MarketplaceMenuDesktop.vue?vue&type=template&id=2aacc53a&scoped=true"
import script from "./MarketplaceMenuDesktop.vue?vue&type=script&lang=js"
export * from "./MarketplaceMenuDesktop.vue?vue&type=script&lang=js"

import "./MarketplaceMenuDesktop.vue?vue&type=style&index=0&id=2aacc53a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aacc53a"]])

export default __exports__